var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "grid-view" },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.view === "list",
              expression: "view==='list'"
            }
          ],
          staticClass: "main-content"
        },
        [
          _c(
            "search-item",
            {
              ref: "searchItem",
              attrs: {
                "config-module": "19212",
                "expand-adv": true,
                "show-simple": false
              },
              on: { advSearchItemCallBack: _vm.queryHandler }
            },
            [
              _c(
                "div",
                { attrs: { slot: "operations" }, slot: "operations" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "success", disabled: !_vm.selectedRow },
                      on: { click: _vm.detail }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_View")))]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { no: "print", type: "success" },
                      on: { click: _vm.toPrint }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Print")))]
                  ),
                  _vm.editShow
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "Edit" },
                          on: { click: _vm.edit }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Edit")))]
                      )
                    : _vm._e(),
                  _vm.cancelCarFormShow
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "danger", no: "Edit" },
                          on: { click: _vm.cancelCarForm }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_CancelVehicleOrder"))
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.sentCarFormShow
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "Edit" },
                          on: {
                            click: function($event) {
                              return _vm.showActionDialog(
                                _vm.SystemConstants.CAR_FORM_ACTION_SENT.code
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_VehicleDispatched"))
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.revokeSentCarStatusShow
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "Edit" },
                          on: {
                            click: function($event) {
                              return _vm.showActionDialog(
                                _vm.SystemConstants.CAR_FORM_ACTION_REVOKE_SENT
                                  .code
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("CargoMsg.Cargo_CancelVehicleStatus"))
                          )
                        ]
                      )
                    : _vm._e(),
                  _vm.finishedShow
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "Edit" },
                          on: {
                            click: function($event) {
                              return _vm.showActionDialog(
                                _vm.SystemConstants.CAR_FORM_ACTION_FINISHED
                                  .code
                              )
                            }
                          }
                        },
                        [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Completed1")))]
                      )
                    : _vm._e(),
                  _vm.revokeFinishedStatusShow
                    ? _c(
                        "el-button",
                        {
                          attrs: { type: "primary", no: "Edit" },
                          on: {
                            click: function($event) {
                              return _vm.showActionDialog(
                                _vm.SystemConstants
                                  .CAR_FORM_ACTION_REVOKE_FINISHED.code
                              )
                            }
                          }
                        },
                        [
                          _vm._v(
                            _vm._s(
                              _vm.$t("CargoMsg.Cargo_CancelCompletedStatus")
                            )
                          )
                        ]
                      )
                    : _vm._e(),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", no: "Edit" },
                      on: { click: _vm.statusUpdateRecordClick }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("CargoMsg.Cargo_StatusUpdateRecord"))
                      )
                    ]
                  )
                ],
                1
              )
            ]
          ),
          _c(
            "div",
            { staticStyle: { "flex-grow": "1", "min-height": "350px" } },
            [
              _c("cargo-ag-grid-wrapper", {
                staticStyle: { height: "100%" },
                attrs: {
                  "config-module": "202506074",
                  "grid-options": _vm.gridOptions,
                  "column-defs": _vm.columnDefs,
                  "row-data": _vm.rowData,
                  "show-selected-color": false,
                  "check-sub-record": false
                },
                on: {
                  gridReady: function(params) {
                    _vm.gridApi = params.api
                  }
                }
              })
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-wrapper" },
            [
              _c("cargo-pagination", {
                attrs: {
                  "config-module": "202506074",
                  total: _vm.filter.total,
                  page: _vm.filter.pageNum,
                  limit: _vm.filter.pageSize
                },
                on: {
                  "update:page": function($event) {
                    return _vm.$set(_vm.filter, "pageNum", $event)
                  },
                  "update:limit": function($event) {
                    return _vm.$set(_vm.filter, "pageSize", $event)
                  },
                  pagination: _vm.fetchDataByPage
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.recordDialog.visible,
            title: _vm.$t("CargoMsg.Cargo_StatusUpdateRecord"),
            width: "600px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.recordDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c("cargo-ag-grid", {
                staticStyle: { width: "100%", height: "300px" },
                attrs: {
                  "show-side-bar": false,
                  "grid-options": _vm.recordDialog.gridOptions,
                  "column-defs": _vm.recordDialog.columnDefs,
                  "row-data": _vm.recordDialog.rowData
                }
              })
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "close" },
                  on: {
                    click: function($event) {
                      _vm.recordDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.close")))]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.actionDialog.visible,
            title: _vm.$t("CargoMsg.Cargo_UpdateVehicleOrderStatus"),
            width: "600px",
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.actionDialog, "visible", $event)
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "100px", "label-position": "left" } },
                [
                  [
                    _vm.SystemConstants.CAR_FORM_ACTION_REVOKE_SENT.code,
                    _vm.SystemConstants.CAR_FORM_ACTION_REVOKE_FINISHED.code
                  ].indexOf(_vm.actionDialog.action) > -1
                    ? _c(
                        "el-form-item",
                        { attrs: { label: _vm.$t("CargoMsg.Cargo_Status") } },
                        [
                          _c(
                            "el-select",
                            {
                              attrs: { no: "status", disabled: "" },
                              model: {
                                value: _vm.actionDialog.status,
                                callback: function($$v) {
                                  _vm.$set(_vm.actionDialog, "status", $$v)
                                },
                                expression: "actionDialog.status"
                              }
                            },
                            _vm._l(
                              _vm.SystemConstants.CAR_FORM_STATUS,
                              function(item) {
                                return _c("el-option", {
                                  key: item.code,
                                  attrs: {
                                    label:
                                      _vm.$store.getters.language === "zh"
                                        ? item.chineseName
                                        : item.englishName,
                                    value: item.code
                                  }
                                })
                              }
                            ),
                            1
                          )
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.SystemConstants.CAR_FORM_ACTION_SENT.code ===
                    _vm.actionDialog.action ||
                  (_vm.SystemConstants.CAR_FORM_ACTION_FINISHED.code ===
                    _vm.actionDialog.action &&
                    _vm.selectedRows &&
                    _vm.selectedRows.length > 0 &&
                    _vm.selectedRows[0].status ===
                      _vm.SystemConstants.CAR_FORM_STATUS_NOT_SENT.code)
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_VehicleTime"),
                            required: ""
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "departureDate",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.actionDialog.departureDate,
                              callback: function($$v) {
                                _vm.$set(_vm.actionDialog, "departureDate", $$v)
                              },
                              expression: "actionDialog.departureDate"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.SystemConstants.CAR_FORM_ACTION_FINISHED.code ===
                  _vm.actionDialog.action
                    ? _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("CargoMsg.Cargo_CompletionTime"),
                            required: ""
                          }
                        },
                        [
                          _c("el-date-picker", {
                            staticStyle: { width: "100%" },
                            attrs: {
                              no: "finishedDate",
                              type: "datetime",
                              "value-format": "yyyy-MM-dd HH:mm:ss",
                              format: "yyyy-MM-dd HH:mm"
                            },
                            model: {
                              value: _vm.actionDialog.finishedDate,
                              callback: function($$v) {
                                _vm.$set(_vm.actionDialog, "finishedDate", $$v)
                              },
                              expression: "actionDialog.finishedDate"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              _c(
                "el-button",
                {
                  attrs: { no: "confirm", type: "primary" },
                  on: { click: _vm.editStatus }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.confirm")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: {
                    click: function($event) {
                      _vm.actionDialog.visible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _vm.view === "detail"
        ? _c("car-form-tab-detail", {
            ref: "carFormTabDetail",
            attrs: { lob: _vm.lob, source: "CarFormTab" },
            on: { back: _vm.back }
          })
        : _vm._e(),
      _c("cargo-template-selector-dialog", {
        attrs: {
          visible: _vm.templateSelectorDialog.visible,
          ctx: _vm.templateSelectorDialog.cxt,
          category: _vm.templateSelectorDialog.category,
          data: _vm.templateSelectorDialog.data
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.templateSelectorDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }